<template>
  <div>
    <div class="content grid justify-center 1.2xl:justify-between mr-3"
         :class="{'grid-cols-1 1.2xl:grid-cols-display-2 1.5xl:grid-cols-display-3 1.8xl:grid-cols-display-4 2.7xl:grid-cols-display-6 4k:grid-cols-display-8': filterOpen,'grid-cols-display-3 1.2xl:grid-cols-display-4 1.5xl:grid-cols-display-4 fhd:grid-cols-display-6 2xl:grid-cols-display-6 2.7xl:grid-cols-display-8 4k:grid-cols-display-12': !filterOpen}">
      <c-product :selectedSelection="selectedSelection" v-for="(product, index) in products"
                 :key="index"
                 :product="product"
                 :displayDelete="false"
                 class="justify-self-center 1.5xl:justify-self-start"
                 :displayQuick="displayQuick"></c-product>
    </div>
    <button v-if="hasMore" class="classen__button justify-self-center hover__button col"
            @click="$emit('load-more')">
      {{ getTranslation('loadMoreItems') }}
    </button>
    <div v-if="products.length === 0" class="">
      {{ getTranslation('noProductsFound') }}
    </div>
  </div>
</template>

<script>
import ProductView from "./ProductView";
import getTranslation from "../../../mixins/getTranslation";

export default {
  name: "ProductsDisplay",

  mixins: [getTranslation],

  props: {
    products: {required: true, type: Array},
    filterOpen: {required: true, type: Boolean},
    hasMore: {required: true, type: Boolean},
    displayQuick: {required: true, type: Boolean},
    selectedSelection: {
      required: true,
      type: Object,
      default: function () {
        return {id: -1, name: "Set default selection"}
      }
    }
  },

  components: {
    'c-product': ProductView,
  },
}
</script>
